import React, { PropsWithChildren } from "react";
import { Item } from "semantic-ui-react";
import InternshipItem from "./InternshipItem";
import { Internship } from "./types";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader";
import useIndustries from "../../app/hooks/useIndustries";
import StudentSeasonAlerts from "../../components/StudentSeasonAlerts";

interface Props {
  internships: Internship[];
  isLoading: boolean;
  onUpdate?: () => void;
}

const InternshipList = ({ internships, isLoading, children, onUpdate }: PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  const { industries: allIndustries } = useIndustries();
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {internships.length > 0 ? (
        <>
          <StudentSeasonAlerts />
          <Item.Group>
            {internships.map((item) => (
              <InternshipItem key={item.id} internship={item} onUpdate={onUpdate} allIndustries={allIndustries} />
            ))}
          </Item.Group>
          {children}
        </>
      ) : (
        t("common.no_records")
      )}
    </>
  );
};

export default InternshipList;
